import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { SplashpageComponent } from './features/splashpage/splashpage.component';
import { NavigationComponent } from './core/navigation/navigation.component';
import { NotfoundComponent } from './core/notfound/notfound.component';
import { LoginComponent } from './core/login/login.component';
import { AuthGuardService } from './core/guards/auth-guard.service';



const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {  path: '',
    children: [ 
      {
        path: '',
        component: NavigationComponent,
        outlet: 'sidenav',
        data: { animation: 'isRight' }
      },
      {
        path: '',
        component: SplashpageComponent,
      },
    ]
  },
  { path: 'CSPOnDemand', loadChildren: () => import('./features/cspondemand/cspondemand.module').then(m => m.CspondemandModule)},
  { path: 'APIReference', loadChildren: () => import('./features/apireference/apireference.module').then(m => m.ApireferenceModule)},
  { path: 'Reporting', loadChildren: () => import('./features/reporting/reporting.module').then(m => m.ReportingModule)},
  { path: 'HotelBooker', loadChildren: () => import('./features/hotelbooker/hotelbooker.module').then(m => m.HotelbookerModule)},
  { path: 'Security', loadChildren: () => import('./features/security/security.module').then(m => m.SecurityModule)},
  { path: '404', component: NotfoundComponent },
  { path: '**', redirectTo: '/404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
    preloadingStrategy: PreloadAllModules
  })], 
  exports: [RouterModule]
})
export class AppRoutingModule { }
